import { render, staticRenderFns } from "./StructureNodes.vue?vue&type=template&id=35b13bd8&"
import script from "./StructureNodes.vue?vue&type=script&lang=js&"
export * from "./StructureNodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports